// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"584":"22c32c97f92569f7","661":"0ee282e6f545a301","691":"4dff555304983e1c"}[chunkId] + ".js";
};